// extracted by mini-css-extract-plugin
module.exports = {"subHeading":"SubHeading_subHeading__2mFMR","separator":"SubHeading_separator__I0iSM"};